import { render, staticRenderFns } from "./UploadImageNew.vue?vue&type=template&id=37b14980&"
import script from "./UploadImageNew.vue?vue&type=script&lang=js&"
export * from "./UploadImageNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports